import { useTodoReminders } from "@/features/todos/hooks/use-todo-reminders";

/**
 * Headless singleton that keeps todo reminders in sync with the platform's
 * notification system. Renders nothing — mount it exactly once inside the
 * PowerSync provider (see `AppProviders`).
 */
export function ReminderScheduler() {
  useTodoReminders();
  return null;
}
